import { ItemBadgeModel } from '@marketplace-web/item-box/product-item-data'
import {
  CurrencyAmountDto,
  CurrencyAmountModel,
  CurrencyConversionDto,
} from '@marketplace-web/currency/currency-data'

export enum ItemThumbnailSize {
  Small = 'thumb70x100',
  Medium = 'thumb150x210',
  Large = 'thumb310x430',
  XLarge = 'thumb364x428',
  X2Large = 'thumb624x428',
}

export type ItemPhotoDto = {
  id: number
  url: string
  dominant_color_opaque: string
  thumbnails: Array<{
    type: ItemThumbnailSize | string
    url: string
  }>
  image_no: number
  is_main: boolean
  orientation?: number | null
}

export type ItemPagePricingPluginModel = {
  badge: ItemBadgeModel | null
  itemId: number
  discountedPrice?: CurrencyAmountDto | null
  isSellerBusiness: boolean
  itemUserId: number
  itemPrice: CurrencyAmountDto
  offerPrice: CurrencyAmountModel | null
  serviceFee?: CurrencyAmountDto | null
  totalItemPrice?: CurrencyAmountDto | null
  itemTitle: string
  photos: Array<ItemPhotoDto>
  conversion: CurrencyConversionDto | null
}
